import { AssetManifest } from "types/version";

export function computeManifestFingerprint(manifest: AssetManifest): string {
  const filePaths: string[] = Object.values(manifest.files || {});
  const entrypoints: string[] = manifest.entrypoints || [];
  const allParts: string[] = [...filePaths, ...entrypoints]
    .filter(Boolean)
    .map((p) => p.trim())
    .sort();
  return allParts.join("|");
}
